module.exports = __webpack_public_path__ + "img/body-shape-side.fec5e78a.svg";